export enum CallForwardingStatusEnum {
  ACTIVE = 'Active',
  SCHEDULED = 'Scheduled',
  EXPIRED = 'Expired',
  CANCELLED = 'Cancelled',
}
